import './LogoStrip.css';

const logos = [
  { src: '/logo1.png.webp', alt: 'Partner Logo 1' },
  { src: '/logo2.png',      alt: 'Partner Logo 2' },
  { src: '/logo3.png.webp', alt: 'Partner Logo 3' },
  { src: '/logo4.png',      alt: 'Partner Logo 4' },
  { src: '/]logo5.png',     alt: 'Partner Logo 5' },
  { src: '/logo6.png',      alt: 'Partner Logo 6' },
];

function LogoStrip() {
  const doubled = [...logos, ...logos];

  return (
    <div className="logo-strip">
      <div className="logo-strip-inner">
        <div className="logo-track">
          {doubled.map((logo, i) => (
            <div key={i} className="logo-item">
              <img src={logo.src} alt={logo.alt} className="logo-img" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default LogoStrip;
